import React from 'react';
import { Handle, Position } from 'reactflow';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';
import { Plus } from 'lucide-react';

// "+N Daha Göster": bir üstün sonraki 100 çocuğunu yükler. Kart kutusuyla aynı ölçü (232×72 — yerleşim tek boyut).
const Wrapper = styled.button`
  width: 232px;
  height: 72px;
  box-sizing: border-box;
  border: 1px dashed rgba(2, 145, 239, 0.45);
  border-radius: 14px;
  background: #fff;
  color: #0291EF;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  /* OrgCard ile aynı gerekçe: ReactFlow sarmalayıcıya pointer-events: none yazar. */
  pointer-events: auto;
  &:disabled { cursor: progress; opacity: 0.7; }
`;

const hiddenHandle = { opacity: 0, width: 1, height: 1, minWidth: 0, minHeight: 0, border: 0 };

export default function MoreNode({ data }) {
  const { t } = useTranslation();
  return (
    <Wrapper
      type="button"
      data-testid={`more-node-${data.parentId}`}
      disabled={Boolean(data.loading)}
      onClick={(e) => {
        e.stopPropagation();
        data.onLoadMore?.(data.parentId);
      }}
    >
      <Handle type="target" position={Position.Top} style={hiddenHandle} isConnectable={false} />
      {data.loading ? <CircularProgress size={14} /> : <Plus size={14} />}
      <span>{t('orgChart.loadMore', { count: data.remaining })}</span>
    </Wrapper>
  );
}
